import { Module } from 'vuex';
import { RootState } from './index';

export interface EstadoLayout {
  sidebarMinimizada: boolean;
}

const state: EstadoLayout = {
  sidebarMinimizada: false,
};

const mutations = {
  DEFINIR_SIDEBAR_MINIMIZADA(state: EstadoLayout, minimizada: boolean) {
    state.sidebarMinimizada = minimizada;
  },
};

const storeLayout: Module<EstadoLayout, RootState> = {
  namespaced: true,
  state,
  mutations,
};

export default storeLayout;
